import { graphql, useStaticQuery, Link } from "gatsby";
import React, { Component } from "react";
import { urlToLink } from "../helper";
import { get } from "lodash";
import Img from "gatsby-image";
import { useMount } from "react-use";

const IntegratedForm = () => {
  const SvgDecoratorBlob1 = ({ className }) => (
    <svg viewBox="0 0 600 600" className={className}>
      <g transform="translate(300,300)">
        <path
          d="M153.6,-239C199.1,-209.8,236,-167.2,258.4,-118C280.9,-68.9,288.9,-13.1,281.2,40.4C273.5,93.9,250.1,145.2,214.7,186.1C179.3,226.9,131.9,257.4,80,272.6C28.2,287.8,-28.2,287.8,-80,272.6C-131.9,257.4,-179.3,226.9,-214.7,186.1C-250.1,145.2,-273.5,93.9,-281.2,40.4C-288.9,-13.1,-280.9,-68.9,-258.4,-118C-236,-167.2,-199.1,-209.8,-153.6,-239C-108.1,-268.3,-54.1,-284.1,0,-284.1C54.1,-284.1,108.1,-268.3,153.6,-239Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );

  useMount(() => {
    if (window.RDStationForms) {
      console.log("window.RDStationForms");
      // Essa linha cria o elemento do formulário e faz o append do conteúdo na div abaixo.
      new window.RDStationForms(
        "formulario-newsletter-em-linha-c812577ae94f3877f816",
        "G-WS1XTZ63CR"
      ).createForm();
    }
  });

  return (
    <div className="bg-purple-200 relative">
      <div className="container relative z-10">
        {/* Esta div é necessária para receber o conteúdo do formulário. Substitua os parâmetros com os dados do seu formulário. */}
        <div
          role="main"
          id="formulario-newsletter-em-linha-c812577ae94f3877f816"
        ></div>
      </div>
      <div className="absolute inset-0 overflow-hidden rounded-lg z-0">
        <SvgDecoratorBlob1 className="absolute bottom-0 left-0 w-80 h-80 transform -translate-x-20 translate-y-32 text-primary-500 opacity-5" />
        <SvgDecoratorBlob1 className="absolute top-0 right-0 w-80 h-80 transform  translate-x-20 -translate-y-64 text-primary-500 opacity-5" />
      </div>
    </div>
  );
};

const Footer = () => {
  const {
    site: {
      meta: { links, email, description, title }
    },
    file,
    blog
  } = useStaticQuery(graphql`
    query FooterQuery {
      blog {
        menus(where: { slug: "header" }) {
          nodes {
            id
            name
            slug
            menuItems {
              nodes {
                id
                url
                label
                isRestricted
              }
            }
          }
        }
      }

      file(name: { eq: "logo" }) {
        childImageSharp {
          # Specify a fixed image and fragment.
          # The default width is 400 pixels
          fixed(height: 46) {
            ...GatsbyImageSharpFixed
          }
        }
      }

      site {
        meta: siteMetadata {
          description
          title
          email
          links {
            facebook
            instagram
            pinterest
            youtube
          }
        }
      }
    }
  `);

  return (
    <>
      {/* <IntegratedForm /> */}
      <section className="bg-red-600 text-white overflow-hidden">
        <footer className="body-font">
          <div className="container px-5 py-24 mx-auto flex md:items-center lg:items-start md:flex-row md:flex-no-wrap flex-wrap flex-col">
            <div className="lg:w-1/2 md:w-1/2 px-2 md:mx-0 text-left md:text-left">
              <Link
                to="/"
                className="flex title-font font-medium items-center md:justify-start justify-center text-gray-900"
              >
                <Img
                  className="lg:h-48 md:h-36 w-full object-cover object-center "
                  fixed={file.childImageSharp.fixed}
                  style={{ filter: "contrast(0.9)" }}
                />
              </Link>
              <p className="mt-2 text-sm text-white text-left">{description}</p>

              <div className="w-full -mb-10 mt-10 text-left">
                <div className="title-font font-medium text-cream-dark tracking-widest text-sm mb-3">
                  LOJAS
                </div>

                <nav className="list-none mb-10">
                  <li className="mb-10">
                    <a
                      href="https://g.page/DreamsIntercambios?share"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p>Recife</p>
                      <address className="text-white hover:text-gray-400">
                        Av. Antônio de Goes 275 - Sala 1102
                        <br /> Pina, Recife, PE - 51110-000
                      </address>
                    </a>
                  </li>
                </nav>

                <div className="title-font font-medium text-cream-dark tracking-widest text-sm mb-3 uppercase">
                  Ponto de Atendimento
                </div>

                <nav className="list-none mb-10">
                  <li>
                    <a
                      href="  https://goo.gl/maps/rpCn7gEVem1pewqu7"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p>João Pessoa</p>
                      <address className="text-white hover:text-gray-400">
                        Empresarial Villa Falcone <br />
                        Av. Gen. Edson Ramalho, 1287 <br />
                        Sala 103 Manaíra
                        <br />
                        João Pessoa, PB. 58038-102
                      </address>
                    </a>
                  </li>
                </nav>
              </div>
            </div>

            <div className="lg:w-1/2 md:w-1/2 px-2 md:px-10  md:mt-0 mt-10 flex flex-col md:ml-auto w-full">
              <div className="title-font font-medium text-cream-dark tracking-widest text-sm mb-3 uppercase">
                Fale conosco
              </div>
              <a
                className="leading-relaxed mb-5 text-white text-sm md:text-md"
                href="mailto:atendimento@dreamsintercambio.com.br"
              >
                atendimento@dreamsintercambio.com.br
              </a>

              <a
                className="leading-relaxed mb-5 text-white"
                href="tel:+558133147121"
              >
                +55 81 3314 7121
              </a>

              <form
                className="contents"
                name="contact"
                method="post"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
              >
                <input type="hidden" name="form-name" value="contact" />
                <input
                  className="text-black bg-red-300 rounded border border-white focus:outline-none focus:border-red-500 text-base px-4 py-2 mb-4 placeholder-white"
                  placeholder="Nome"
                  type="text"
                  name="name"
                />
                <input
                  className="text-black bg-red-300 rounded border border-white focus:outline-none focus:border-red-500 text-base px-4 py-2 mb-4 placeholder-white"
                  placeholder="Whatsapp"
                  type="text"
                  name="phone"
                  required
                />
                <input
                  className="text-black bg-red-300 rounded border border-white focus:outline-none focus:border-red-500 text-base px-4 py-2 mb-4 placeholder-white"
                  placeholder="E-mail"
                  type="email"
                  name="E-mail"
                />
                <textarea
                  className="text-black bg-red-300 rounded border border-white focus:outline-none h-32 focus:border-red-500 text-base px-4 py-2 mb-4 resize-none placeholder-white"
                  placeholder="Mensagem"
                  name="message"
                ></textarea>
                <button
                  type="submit"
                  className="text-white bg-green-500 border-0 py-2 px-6 focus:outline-none hover:bg-green-600 rounded text-lg"
                >
                  Enviar
                </button>
              </form>
            </div>
          </div>

          <div className="container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row list-none">
            {get(blog, "menus.nodes[0].menuItems.nodes", []).map(menu => (
              <li key={menu.label}>
                <Link
                  className="block mt-4 uppercase underline hover:no-underline   md:inline-block md:mt-0 md:ml-6 md:text-xs"
                  key={menu.label}
                  to={urlToLink(menu.url)}
                >
                  {menu.label}
                </Link>
              </li>
            ))}
          </div>

          <div className="container mx-auto py-4 px-5 flex flex-wrap flex-col sm:flex-row">
            <p className="text-cream-dark text-sm text-center sm:text-left">
              © 2022 {title} —
              <a
                href={`mailto:${email}`}
                rel="noopener noreferrer"
                className="text-white ml-1"
                target="_blank"
              >
                {email}
              </a>
            </p>
            <span className="inline-flex sm:ml-auto sm:mt-0 mt-2 justify-center sm:justify-start">
              <a
                href={links.facebook}
                target="_blank"
                rel="noreferrer"
                className="text-white"
              >
                <svg
                  fill="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                >
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
                </svg>
              </a>

              <a
                href={links.instagram}
                target="_blank"
                rel="noreferrer"
                className="ml-3 text-white"
              >
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  className="w-5 h-5"
                  viewBox="0 0 24 24"
                >
                  <rect width="20" height="20" x="2" y="2" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zm1.5-4.87h.01"></path>
                </svg>
              </a>

              <a
                href={links.pinterest}
                target="_blank"
                rel="noreferrer"
                className="ml-3 text-white"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  viewBox="0 0 310.433 313.65"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M 153.803 3.76 C 69.585 3.76 1.313 72.032 1.313 156.25 C 1.313 220.852 41.506 276.079 98.231 298.297 C 96.899 286.232 95.694 267.677 98.76 254.506 C 101.531 242.605 116.641 178.709 116.641 178.709 C 116.641 178.709 112.08 169.574 112.08 156.069 C 112.08 134.865 124.37 119.035 139.673 119.035 C 152.683 119.035 158.966 128.802 158.966 140.515 C 158.966 153.599 150.636 173.16 146.338 191.287 C 142.745 206.465 153.949 218.842 168.919 218.842 C 196.021 218.842 216.855 190.265 216.855 149.014 C 216.855 112.502 190.62 86.975 153.159 86.975 C 109.77 86.975 84.303 119.519 84.303 153.151 C 84.303 166.257 89.351 180.311 95.651 187.951 C 96.898 189.461 97.08 190.784 96.709 192.325 C 95.551 197.141 92.979 207.499 92.474 209.619 C 91.809 212.41 90.264 213.002 87.374 211.657 C 68.329 202.792 56.421 174.947 56.421 152.582 C 56.421 104.48 91.371 60.304 157.178 60.304 C 210.076 60.304 251.185 97.999 251.185 148.375 C 251.185 200.929 218.049 243.224 172.056 243.224 C 156.604 243.224 142.078 235.196 137.105 225.714 C 137.105 225.714 129.459 254.829 127.605 261.964 C 124.163 275.209 114.869 291.811 108.653 301.94 C 122.92 306.357 138.083 308.74 153.803 308.74 C 238.021 308.74 306.294 240.467 306.294 156.25 C 306.294 72.032 238.021 3.76 153.803 3.76" />
                </svg>
              </a>

              <a
                href={links.youtube}
                target="_blank"
                rel="noreferrer"
                className="ml-3 text-white"
              >
                <svg
                  className="w-5 h-5"
                  fill="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  viewBox="0 -62 513.218 392.103"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g transform="matrix(1, 0, 0, 1, 0.248, -55.789001)">
                    <path d="M 334.809 170.992 L 221.695 109.102 C 215.191 105.543 207.504 105.676 201.129 109.453 C 194.75 113.234 190.945 119.914 190.945 127.328 L 190.945 250.047 C 190.945 257.426 194.727 264.094 201.063 267.879 C 204.371 269.855 208.039 270.848 211.715 270.848 C 215.082 270.848 218.457 270.016 221.563 268.344 L 334.68 207.52 C 341.395 203.906 345.586 196.926 345.617 189.297 C 345.645 181.668 341.504 174.656 334.809 170.992 Z M 220.949 234.609 L 220.949 142.891 L 305.488 189.148 Z M 220.949 234.609" />
                    <path d="M 507.986 86.316 L 507.963 86.082 C 507.529 81.961 503.213 45.304 485.392 26.66 C 464.795 4.73 441.443 2.066 430.213 0.789 C 429.283 0.683 428.432 0.586 427.67 0.484 L 426.775 0.39 C 359.088 -4.532 256.865 -5.204 255.842 -5.207 L 255.752 -5.211 L 255.662 -5.207 C 254.639 -5.204 152.416 -4.532 84.119 0.39 L 83.217 0.484 C 82.49 0.582 81.689 0.671 80.818 0.773 C 69.717 2.054 46.615 4.722 25.959 27.445 C 8.986 45.89 4.08 81.761 3.576 85.793 L 3.517 86.316 C 3.365 88.031 -0.248 128.855 -0.248 169.839 L -0.248 208.152 C -0.248 249.136 3.365 289.961 3.517 291.679 L 3.545 291.937 C 3.978 295.992 8.291 331.976 26.029 350.628 C 45.396 371.824 69.885 374.628 83.057 376.136 C 85.139 376.375 86.932 376.578 88.154 376.793 L 89.338 376.957 C 128.42 380.675 250.955 382.507 256.15 382.582 L 256.307 382.586 L 256.463 382.582 C 257.486 382.578 359.705 381.906 427.392 376.984 L 428.287 376.89 C 429.142 376.777 430.103 376.675 431.158 376.566 C 442.197 375.394 465.174 372.961 485.545 350.546 C 502.517 332.097 507.428 296.226 507.928 292.199 L 507.986 291.675 C 508.139 289.957 511.756 249.136 511.756 208.152 L 511.756 169.839 C 511.752 128.855 508.139 88.035 507.986 86.316 Z M 481.748 208.152 C 481.748 246.086 478.435 285.152 478.123 288.738 C 476.849 298.617 471.674 321.312 463.404 330.3 C 450.654 344.328 437.557 345.718 427.994 346.73 C 426.838 346.851 425.767 346.968 424.799 347.089 C 359.33 351.824 260.967 352.55 256.435 352.578 C 251.353 352.503 130.611 350.656 92.721 347.136 C 90.779 346.82 88.682 346.578 86.471 346.328 C 75.256 345.043 59.904 343.285 48.099 330.3 L 47.822 330.003 C 39.697 321.539 34.67 300.316 33.392 288.855 C 33.154 286.144 29.756 246.617 29.756 208.152 L 29.756 169.839 C 29.756 131.949 33.06 92.925 33.381 89.265 C 34.9 77.628 40.174 56.308 48.099 47.691 C 61.24 33.238 75.096 31.636 84.26 30.578 C 85.135 30.476 85.951 30.382 86.705 30.285 C 153.127 25.527 252.197 24.82 255.752 24.793 C 259.307 24.816 358.342 25.527 424.174 30.285 C 424.982 30.386 425.865 30.488 426.814 30.597 C 436.24 31.671 450.486 33.296 463.56 47.242 L 463.682 47.371 C 471.807 55.836 476.834 77.429 478.111 89.121 C 478.338 91.679 481.748 131.293 481.748 169.839 Z M 481.748 208.152" />
                  </g>
                </svg>
              </a>
            </span>
          </div>
        </footer>
      </section>
    </>
  );
};

export default Footer;
